import { Box } from '@mui/material';
import homeMessages from 'client/modules/Public/pages/HomePage/homeMessages';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

import Layout from 'client/modules/App/components/Layout/LayoutContainer';
import Features from './components/Features/Features';
import Home from './components/Home/Home';
import Nav from './components/Nav/NavContainer';
import Product from './components/Product/Product';
import Testimonials from './components/Testimonials/TestimonialsContainer';

import { homeAnchorSx } from './homeSsrStyles';

function HomePage(props) {
  const {
    intl: { formatMessage },
    surveyType,
    locale: lang,
  } = props;
  const title = formatMessage(homeMessages.title);
  const description = formatMessage(homeMessages.description);
  return (
    <Layout
      showHeader={false}
      title={title}
      description={description}
      disableGutters
    >
      <Helmet htmlAttributes={{ lang }}>
        <link rel="alternate" hrefLang="es" href="https://www.promoter.ninja/es" />
        <link rel="alternate" hrefLang="en" href="https://www.promoter.ninja/en" />
        <link rel="alternate" hrefLang="x-default" href="https://www.promoter.ninja" />
        <meta httpEquiv="Content-Language" content={lang} />
        {surveyType ? <meta name="robots" content="noindex,nofollow" /> : null}
      </Helmet>
      <Nav {...{ surveyType }} />
      <Box id="sec-home-a" sx={homeAnchorSx} />
      <Box id="sec-home">
        <Home surveyType={surveyType} />
      </Box>
      <Box id="sec-features-a" sx={homeAnchorSx} />
      <Box id="sec-features">
        <Features />
      </Box>
      <Box id="sec-product-a" sx={homeAnchorSx} />
      <Box id="sec-product">
        <Product surveyType={surveyType || 'generic'} />
      </Box>
      <Box id="sec-testimonials">
        <Testimonials />
      </Box>
    </Layout>
  );
}

HomePage.defaultProps = {
  surveyType: undefined,
};

HomePage.propTypes = {
  intl: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  surveyType: PropTypes.string,
};

export default injectIntl(HomePage);
